import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Routes } from 'lib/constants';
import axiosInstance from 'lib/react-query/axios';
import { PublicSignupResponse, UserCreateData } from 'types/models/User';

type PublicUserCreateData = Omit<UserCreateData, 'role'>;

const createUser = async (user: PublicUserCreateData) => {
  const { data } = await axiosInstance.post<PublicSignupResponse>(
    Routes.API.USERS,
    user
  );
  return data;
};

export const useCreateUser = () => {
  const mutation = useMutation<
    PublicSignupResponse,
    AxiosError,
    PublicUserCreateData,
    unknown
  >({
    mutationFn: (user) => createUser(user),
  });

  return mutation;
};
